import { getAttendeeCustomFieldAnswer, modificationStart, getCurrentGuestCustomFieldAnswer, modificationStartForCurrentGuest } from '../../redux/selectors/currentRegistrant';
import { filterFieldChoicesByLinkLogic } from 'event-widgets/redux/selectors/account';
import { createSelector } from 'reselect';

export function getValues(answer: any) {
  return answer && answer.answers ?
    answer.answers.filter(entry => entry.answerType === 'Choice').map(entry => entry.choice) : [];
}

export function createChoiceSelectors() {
  const getSelectedValues = createSelector(
    onGuestPage => onGuestPage ? getCurrentGuestCustomFieldAnswer :
      getAttendeeCustomFieldAnswer, getValues);
  const getPreviouslySelectedValues = createSelector(
    onGuestPage => onGuestPage ? modificationStartForCurrentGuest :
      modificationStart.getAttendeeCustomFieldAnswer, getValues);
  const filterChoicesByLinkLogic = createSelector(
    (state, fieldDefinition) => fieldDefinition,
    (state, fieldDefinition, onGuestPage) => {
      if (!fieldDefinition.question.questionTypeInfo.linkLogic) {
        return null;
      }
      return (onGuestPage ? getCurrentGuestCustomFieldAnswer : getAttendeeCustomFieldAnswer)(
        state, fieldDefinition.question.questionTypeInfo.linkLogic.parentQuestionId);
    },
    (fieldDefinition, parentAnswer) => filterFieldChoicesByLinkLogic(fieldDefinition, getValues(parentAnswer)));
  return { getSelectedValues, getPreviouslySelectedValues, filterChoicesByLinkLogic };
}
